import { ICredentialsService } from "../../service/authentication/CredentialsService";

export default class GetSelectedLanguageInteractor {
  private credentialsService: ICredentialsService;

  constructor(credentialsService) {
    this.credentialsService = credentialsService;
  }

  async execute() {
    const selectedLanguage = await this.credentialsService.getLanguage();
    return Number(selectedLanguage);
  }
}
